var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { saveAs } from 'file-saver';
import services from '../../services';
import { IMPORT_EXCEL_REQUEST, IMPORT_EXCEL_SUCCESS, IMPORT_EXCEL_FAILURE, ADD_USER_REQUEST, ADD_USER_SUCCESS, ADD_USER_FAILURE, DOWNLOAD_EXCEL_TEMPLATE_REQUEST, DOWNLOAD_EXCEL_TEMPLATE_SUCCESS, DOWNLOAD_EXCEL_TEMPLATE_FAILURE, } from './constants';
var UserService = services.UserService;
export var createUser = function (_a) {
    var appId = _a.appId, user = _a.user, sendInviteEmail = _a.sendInviteEmail, externalUser = _a.externalUser, userAppId = _a.userAppId, groups = _a.groups, organizationId = _a.organizationId;
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var createdUser, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: ADD_USER_REQUEST });
                    if (organizationId === 'shared') {
                        organizationId = '';
                    }
                    return [4 /*yield*/, UserService.createUser({
                            appId: appId,
                            user: user,
                            sendInviteEmail: sendInviteEmail,
                            externalUser: externalUser,
                            userAppId: userAppId,
                            groups: groups,
                            organizationId: organizationId,
                        })];
                case 1:
                    createdUser = (_a.sent()).object;
                    dispatch({ type: ADD_USER_SUCCESS, createdUsers: [createdUser] });
                    return [2 /*return*/, createdUser];
                case 2:
                    err_1 = _a.sent();
                    dispatch({ type: ADD_USER_FAILURE });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var importExcel = function (appId, file, sendInviteEmail, externalUser, userAppId, groups, organization) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, createdUsers, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: IMPORT_EXCEL_REQUEST });
                    formData = new FormData();
                    formData.append('excel_file', file);
                    formData.append('send_invite_email', sendInviteEmail);
                    formData.append('external_user', externalUser);
                    formData.append('userAppId', userAppId);
                    formData.append('groups', groups);
                    if (organization)
                        formData.append('organization', organization);
                    return [4 /*yield*/, UserService.importExcel(formData, appId)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    createdUsers = (_a.sent()).objects;
                    dispatch({ type: IMPORT_EXCEL_SUCCESS, createdUsers: createdUsers });
                    return [2 /*return*/, createdUsers];
                case 3:
                    err_2 = _a.sent();
                    dispatch({ type: IMPORT_EXCEL_FAILURE });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    }); };
};
export var importExcelTemplate = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: DOWNLOAD_EXCEL_TEMPLATE_REQUEST,
                });
                return [4 /*yield*/, UserService.importExcelTemplate()];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                saveAs(blob, 'usersExcelTemplate.xlsx');
                dispatch({
                    type: DOWNLOAD_EXCEL_TEMPLATE_SUCCESS,
                });
                return [3 /*break*/, 4];
            case 3:
                err_3 = _a.sent();
                dispatch({
                    type: DOWNLOAD_EXCEL_TEMPLATE_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
